<template>
  <div class="con">
    <div class="con_title">{{ title }}</div>
    <div class="con_list clearfix">
      <div class="text-list" v-for="(item, index) in powerList" :key="index">
        <div class="top">{{ item.name }}</div>
        <div class="right">
          <div>
            <div class="text1">{{ item.toWho }}</div>
            <div class="text2" v-for="(subitem, subindex) in item.descList" :key="subindex">{{ subitem }}</div>
            <div class="link" @click="dialogShow">
              <span>{{ item.link }}</span>
              <div class="icon"></div>
            </div>
          </div>
          <img class="icon" :src="item.iconUrl" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    powerList: Array,
  },
  data() {
    return {
      openSwitch: 0,
    }
  },
  methods: {
    dialogShow() {
      this.$emit('showDialog')
    },
  },
}
</script>

<style lang="less" scoped>
.con {
  padding: 0.9067rem 0.32rem 1.12rem 0.32rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  background: #ffffff;
  .con_title {
    font-size: 0.48rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
  }
  .clearfix:after {
    content: '';
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }
  .con_list {
    width: 100%;
    .text-list {
      width: 100%;
      margin-top: 0.5333rem;
      .top {
        width: 100%;
        height: 0.6933rem;
        background: #e63740;
        border-radius: 0.1067rem 0.1067rem 0px 0px;
        text-align: center;
        line-height: 0.6933rem;
        color: #fff;
        font-weight: 500;
        font-size: 0.3733rem;
      }
      &:hover {
        background: #ffffff;
        box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.1);
        border-radius: 5px;
      }
      .right {
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding: 0 0.16rem;
        box-shadow: 2px 2px 6px 0px rgba(205, 213, 226, 0.28);
        border-radius: 0.1067rem;
        padding: 0.4533rem 0.16rem 0.4267rem 0.5333rem;
        img {
          width: 2.64rem;
          height: 2.1333rem;
        }
        .text1 {
          font-size: 0.3733rem;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.85);
          margin-bottom: 0.1333rem;
        }
        .text2 {
          position: relative;
          font-size: 0.32rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.65);
          line-height: 0.5867rem;
          padding-left: 0.3rem;
          &::before {
            content: ' ';
            position: absolute;
            display: block;
            width: 0.08rem;
            height: 0.08rem;
            border-radius: 50%;
            background-color: #e61717;
            left: 0;
            top: 0.26rem;
          }
        }
      }
      .link {
        margin-top: 0.2667rem;
        display: flex;
        align-items: center;
        font-size: 0.3733rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #e61717;
        line-height: 0.5333rem;
        cursor: pointer;
        .icon {
          width: 1.0667rem;
          height: 0.4rem;
          background: url('../../../../assets/images/goIn.gif');
          background-size: contain;
          background-repeat: no-repeat;
        }
      }
    }
  }
}
</style>
